import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; // <-- NgModel lives here
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Angular2UsefulSwiperModule } from 'angular2-useful-swiper';
import { AppComponent } from './app.component';
import { RUTEO } from './app.routes';
import { InicioComponent } from './inicio/inicio.component';
import { ListaCheckboxComponent } from './Componentes/menu/lista-checkbox.component';
import { MenuComponent } from './Componentes/menu/menu.component';
import { ProductosComponent } from './Componentes/productos/productos.component';
import { ServiciosModule } from './Servicios/servicios.module';
import { UtilidadesModule } from './utilidades/utilidades.module';
import { CarritoDeComprasComponent } from './Componentes/carrito-de-compras/carrito-de-compras.component';
import { UpDownComponent } from './Componentes/up-down/up-down.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { ContactoComponent } from './contacto/contacto.component';
import { RouterModule } from '@angular/router';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { DownloadsComponent } from './downloads/downloads.component';
import { FooterComponent } from './footer/footer.component';
import { SwiperProductsComponent } from './inicio/swiper-products/swiper-products.component';
import { ButtonComponent } from './Componentes/button/button.component';
import { SwiperBrandComponent } from './inicio/swiper-brand/swiper-brand.component';
import { SearchSectionComponent } from './search-section/search-section.component';
import { SwiperServicesComponent } from './inicio/swiper-services/swiper-services.component';
import { ServicesComponent } from './services/services.component';
import { ListaMultiCheckboxComponent } from './Componentes/menu/lista-multi-checkbox.component';
import { ListaSortComponent } from './Componentes/menu/lista-sort.component';
import { SwiperHomeComponent } from './inicio/swiper-home/swiper-home.component';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
	declarations: [
		AppComponent,
		InicioComponent,
		MenuComponent,
		ListaCheckboxComponent,
		ProductosComponent,
		CarritoDeComprasComponent,
		UpDownComponent,
		ContactoComponent,
		NavBarComponent,
		AboutUsComponent,
		DownloadsComponent,
		FooterComponent,
		SwiperProductsComponent,
		ButtonComponent,
		SwiperBrandComponent,
		SearchSectionComponent,
		SwiperServicesComponent,
		ServicesComponent,
		ListaMultiCheckboxComponent,
		ListaSortComponent,
		SwiperHomeComponent
	],
	imports: [
		RUTEO,
		CommonModule,
		BrowserModule,
		FormsModule,
		MatExpansionModule,
		UtilidadesModule,
		Angular2UsefulSwiperModule,
		BrowserAnimationsModule,
		ServiciosModule,
		RecaptchaModule,
		ReactiveFormsModule
	],
	exports: [RouterModule],
	bootstrap: [AppComponent]
})
export class AppModule { }